export default __webpack_public_path__ + "static/media/Ramadan_V2_800x300.243a8db2.jpg";